module.exports = __webpack_public_path__ + "img/sidebar-4.5e6ee864.jpg";